
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { ColorEnum } from '../../../enums'
import { EpbText } from '../../shared/epb-text'

export interface Item {
  id: string
  name?: string
  count: number
  percentage: number
}

export default defineComponent({
  name: 'ItemsList',
  components: { EpbText },
  props: {
    items: Array as PropType<Array<Item>>,
    selectedIds: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    valueLabel: String,
  },
  setup() {
    return {
      ColorEnum,
    }
  },
  methods: {
    getItemCountText(item: Item): string {
      let itemCountText = item.count.toLocaleString(this.$epb.locale)
      if (this.valueLabel) {
        itemCountText += ` ${this.valueLabel}`
      }
      return itemCountText
    },
    hasPercentage(item: Item): boolean {
      return item.percentage !== undefined
    },
    getItemPercentageText(item: Item): string {
      return `(${item.percentage.toLocaleString(this.$epb.locale, {
        maximumSignificantDigits: 3,
      })}%)`
    },
  },
})
